/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SigninType = {
  type: 'Enum',
} as const;
